var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flowdesign-container"
  }, [_c('my-process-designer', _vm._b({
    key: "designer-".concat(_vm.reloadIndex),
    ref: "processDesigner",
    attrs: {
      "options": {
        taskResizingEnabled: true,
        eventResizingEnabled: true,
        minimap: {
          open: true
        }
      },
      "keyboard": "",
      "processName": _vm.processName
    },
    on: {
      "element-click": _vm.elementClick,
      "element-contextmenu": _vm.elementContextmenu,
      "init-finished": _vm.initModeler
    },
    model: {
      value: _vm.xmlString,
      callback: function callback($$v) {
        _vm.xmlString = $$v;
      },
      expression: "xmlString"
    }
  }, 'my-process-designer', _vm.controlForm, false)), _c('my-properties-panel', {
    key: "penal-".concat(_vm.reloadIndex),
    staticClass: "process-panel",
    staticStyle: {
      "padding": "0px",
      "background-color": "#fff"
    },
    attrs: {
      "bpmn-modeler": _vm.modeler,
      "prefix": _vm.controlForm.prefix,
      "formFieldArr": _vm.formFieldArr,
      "userList": _vm.userList
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };